import { ApiQueries, DaymapIcon, DaymapIconType, NoItems, NoteItem, useStudent, DaymapSkeleton } from "daymap-react";
import { PageContainer, PageDescriptor } from "../../../components/layout";
import { Alert, Box, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { useState } from "react";

const now = new Date();
const currentYear = now.getFullYear();



export function Notes() {
    const [categoryId, setCategoryId] = useState(0);
    const [year, setYear] = useState(currentYear);
    const {studentId} = useParams();
    const student = useStudent(Number(studentId));
    const { isPending, data, error } = new ApiQueries.student.YearsAndClasses({studentId: Number(studentId)}).ToQuery();
    const { isPending: pendingCategories, data: categories, error: categoriesError } = new ApiQueries.notes.StudentNoteCategories().ToQuery();
        
    //const { categoryId, year } = state;
    
    if (isPending || pendingCategories)
        return <PageContainer>
            <DaymapSkeleton type="page" />
        </PageContainer>
    
    const { years } = data!;

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Note} />} title="Notes">
            View notes for {student?.Displayname}
        </PageDescriptor>
        { error && <Alert severity="error" title={error.title}>
            {error.detail}
        </Alert>}
        { categoriesError && <Alert severity="error" title={categoriesError.title}>
            {categoriesError.detail}
        </Alert>}
        {years && categories && <Box pt={2} display="flex" gap={1}>
            <FormControl sx={{ minWidth: 150 }}>
                <InputLabel id="year-label">Year</InputLabel>
                <Select
                    labelId="year-label"
                    id="year"
                    value={year}
                    label="Year"
                    onChange={e => setYear(Number(e.target.value))}
                >
                    {years.indexOf(currentYear) < 0 && <MenuItem value={currentYear}>{currentYear}</MenuItem>}
                    {years.sort((a, b) => b-a).map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 150 }}>
                <InputLabel id="category-label">Category</InputLabel>
                <Select
                    labelId="category-label"
                    id="category"
                    value={categoryId.toString()}
                    label="Category"
                    onChange={e => setCategoryId(Number(e.target.value))}
                >
                    <MenuItem value="0">All</MenuItem>
                    {categories!.sort((a, b) => a.Caption.localeCompare(b.Caption)).map(d => <MenuItem key={d.CategoryID} value={d.CategoryID}>{d.Caption}</MenuItem>)}
                </Select>
            </FormControl>
        </Box>}
        <NotesList studentId={Number(studentId)} categoryId={categoryId} year={year} />
    </PageContainer>
}

type NotesListProps = {
    studentId: number;
    categoryId: number;
    year: number;
}

const NotesList:React.FC<NotesListProps> = ({ studentId, categoryId, year }) => {
    const { isPending, data, error } = new ApiQueries.notes.StudentNotes({studentId: Number(studentId), from: new Date(year, 0, 1), to: new Date(year, 11, 31)}).ToQuery();

    if (isPending)
        return <DaymapSkeleton type="listitems" />

    if (error)
        return <Alert severity="error" title={error.title}>{error.detail}</Alert>

    const filteredNotes = data?.filter(n => categoryId === 0 || n.Category.CategoryID === categoryId);

    return <Stack spacing={1} pt={3}>
        {(!filteredNotes || filteredNotes.length === 0) && <NoItems>No notes to display</NoItems>}
        {filteredNotes?.sort((a,b) => b.NoteDate.getTime() - a.NoteDate.getTime()).map(n => <NoteItem key={n.ID} {...n} />)}
    </Stack>
}